import { createContext, useContext, PropsWithChildren } from 'react';
import type { ToastMessage } from 'primereact/toast';
import type { StepConfig } from '../types';

export interface StepperDialogContextValues {
    registerProceed: (handler: () => boolean | Promise<boolean>) => void;
    setPrimaryDisabled: (
        disabled: boolean,
        options?: { isInvalid?: boolean },
    ) => void;
    showToast: (message: ToastMessage) => void;
}

export const StepperDialogContext = createContext<StepperDialogContextValues>({
    registerProceed: () => {},
    setPrimaryDisabled: () => {},
    showToast: () => {},
});

export const StepIndexContext = createContext<number | undefined>(undefined);
export const StepperDialogStepsContext = createContext<{
    setSteps: (steps: StepConfig[]) => void;
}>({
    setSteps: () => {},
});

export function StepIndexProvider({
    index,
    children,
}: PropsWithChildren<{ index: number }>) {
    return (
        <StepIndexContext.Provider value={index}>
            {children}
        </StepIndexContext.Provider>
    );
}

export function useStepperDialog(): StepperDialogContextValues & {
    index?: number;
} {
    const context = useContext(StepperDialogContext);
    const index = useContext(StepIndexContext);
    return { ...context, index };
}

export function useStepperDialogSteps(): {
    setSteps: (steps: StepConfig[]) => void;
} {
    return useContext(StepperDialogStepsContext);
}
